import React, {Component} from "react";
import {TouchableOpacity, View, Text, Image, I18nManager} from "react-native";
import Colors from "../tools/Colors";
import HMTextView from "./HMTextView";
import {moderateScale} from "../tools/Scaling";
import HMIcon from "./HMIcon";

export default class HMListItem extends Component {
    render() {
        const {text, textStyle, textType, style, type, borderRadius, height, NoShowIconOnpress, onPress, title, title2, image,typeIcon} = this.props;
        return (
            <TouchableOpacity
                style={{
                    margin: moderateScale(2),
                    backgroundColor: Colors.white,
                    borderRadius: moderateScale(6),
                    marginHorizontal: moderateScale(6),
                    paddingVertical:moderateScale(6)
                }}
                onPress={onPress}
            >
                <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>

                    <View style={{flexDirection: 'row', padding: moderateScale(6)}}>

                        <View style={{

                            backgroundColor: Colors.light,
                            height: moderateScale(28),
                            width: moderateScale(28),
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: moderateScale(6),
                            borderWidth: 0.9,
                            borderColor: Colors.light,
                            alignSelf: 'center',
                            // padding:moderateScale(8)

                        }}>
                            {/*<Image source={image ? image : null}*/}
                            {/*style={{*/}
                            {/*alignSelf: 'center',*/}
                            {/*width: moderateScale(24),*/}
                            {/*height: moderateScale(24),*/}
                            {/*// tintColor: Colors.gray*/}
                            {/*}}/>*/}
                            <HMIcon
                                type={typeIcon}
                                name={image}
                                  style={{
                                      fontSize: moderateScale(20),
                                      color: Colors.colorDark,
                                      textAlign: "center",
                                      padding: moderateScale(4),

                                  }}/>
                        </View>
                        <View style={{width: moderateScale(14)}}/>

                        <View style={{
                            flexDirection: 'row', justifyContent: 'center', alignItems: 'center', alignSelf: 'center'
                        }}>

                            <HMTextView text={title} type={"bold"}
                                        style={{

                                            fontSize: moderateScale(12),
                                            color: Colors.colorDark,
                                            textAlign: "center"
                                        }}/>

                            {
                                title2 ?
                                    <HMTextView text={title2} type={"bold"}
                                                style={{

                                                    fontSize: moderateScale(12),
                                                    color: Colors.gray,
                                                    textAlign: "center",
                                                    marginHorizontal: moderateScale(4)
                                                }}/>
                                    :
                                    null
                            }
                        </View>


                    </View>
                    <View style={{alignItems: 'center', justifyContent: 'center'}}>
                        {
                            !NoShowIconOnpress ?
                                <TouchableOpacity
                                    style={{alignSelf: 'center'}}
                                    onPress={() => {
                                    }}
                                >
                                    <HMIcon name={I18nManager.isRTL ? "ios-arrow-back" : 'ios-arrow-forward'}
                                          style={{
                                              fontSize: moderateScale(20),
                                              color: Colors.gray,
                                              textAlign: "center",
                                              padding: moderateScale(4),

                                          }}/>
                                </TouchableOpacity>
                                :
                                null
                        }

                    </View>
                </View>

                {/*
                <View style={{width: '100%', height: moderateScale(.7), backgroundColor: Colors.gray3}}/>
*/}
            </TouchableOpacity>
        );
    }
}
